module.exports = __webpack_public_path__ + "static/media/taxa5.8d46ebe3.png";